/**
 * Maximum number of days to keep track of puzzle wins
 */
export const puzzleWinCountDays = 7;
